import React from 'react'
import { FormControl, Typography, Box } from '@mui/material'
import { type RadioButtonGroupProps, type FieldValues } from 'react-hook-form-mui'
import CustomRadioButtonGroup, { getId } from '../../../../components/CustomRadioButtonGroup'
import { InvalidQuestionError } from '../../styles'
import QuestionHeader from '../../../StudentSurveyListFeature/components/QuestionHeader'
import { grey } from '../../../../colors'

interface MultipleChoiceCardProps extends Omit<RadioButtonGroupProps<FieldValues>, 'options'> {
  title: string
  options: string[]
  questionNumber: number
  invalidQuestionItemId: string | undefined
  isRequired: boolean
}

const MultipleChoiceCard: React.FC<MultipleChoiceCardProps> = (
  {
    title,
    name,
    options,
    disabled = false,
    questionNumber,
    isRequired,
    invalidQuestionItemId,
    ...rest
  }
): JSX.Element => {
  const { onChange } = rest

  return (
    <Box tabIndex={0} aria-label={`Survey Question ${questionNumber} ${title}`} id={name} sx={{ p: '14px 18px', border: `1px solid ${grey[200]} `, borderRadius: '10px' }}>
      <QuestionHeader onChange={onChange} isRequired={isRequired} name={name} />
      {invalidQuestionItemId && invalidQuestionItemId === name && <InvalidQuestionError>*Response required. Please answer and submit again.</InvalidQuestionError> }
        <Typography variant="h5" color={disabled ? 'text.secondary' : 'text.primary'} my={2}>
          {questionNumber}. {title}
        </Typography>
        <FormControl aria-label={title} aria-owns={options.map((value) => getId(name, value.toString())).join(' ')}>
          <CustomRadioButtonGroup
            name={name}
            type="string"
            options={options.map((value) => {
              return {
                id: value,
                label: value
              }
            })}
            {...rest} />
        </FormControl>
    </Box>
  )
}

export default MultipleChoiceCard
